import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from '../../services/authentication.service'
import { NotificationService } from '../../services/notification.service'
import { ViewValidation }  from '../../_helpers/ViewValidation'

@Component({
	selector: 'app-remember-password',
	templateUrl: './remember-password.component.html'
})
export class RememberPasswordComponent implements OnInit {

	public loading: boolean = false
	public data: string
	public ViewValidation: ViewValidation = new ViewValidation()

	constructor(private router: Router,
		           private authenticationService: AuthenticationService,
		           private notificationService: NotificationService) { }

	public ngOnInit() {
		this.notificationService.starterLoading.subscribe(() => this.loading = true)
		this.notificationService.stopperLoading.subscribe(() => this.loading = false)
	}

	public rememberPassword() {
		this.authenticationService.rememberPassword(this.data).subscribe(
			success => {
				this.notificationService.notify('Enviamos um email para você com as instruções!', 200)
				this.router.navigate(['/login'])
			}, error => {
				this.notificationService.notify('Erro ao tentar recuperar senha!', 400)
			})
	}
}
